var _path, _path2, _rect, _path3, _rect2, _path4, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 63,
    viewBox: "0 0 34 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 20.2881H10.625C10.625 20.2881 10.625 37.3728 10.625 41.644C10.625 45.9152 14.4583 60.9058 14.4583 60.9058C14.7006 62.1235 15.7644 62.9999 17 62.9999C18.2356 62.9999 19.2995 62.1235 19.5418 60.9058C19.5418 60.9058 23.375 45.9152 23.375 41.644C23.375 37.3728 23.375 20.2881 23.375 20.2881Z",
    fill: "#868CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 21.3558H11.6875C11.6875 21.3558 11.6875 37.3728 11.6875 41.644C11.6875 45.9152 15.0875 59.7965 15.0875 59.7965C15.2895 60.9533 15.9704 61.9321 17 61.9321C18.0297 61.9321 18.7106 60.9533 18.9125 59.7965C18.9125 59.7965 22.3125 45.9152 22.3125 41.644C22.3125 37.3728 22.3125 21.3558 22.3125 21.3558Z",
    fill: "#CBCDD8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.50003,
    y: 20.2881,
    width: 17.5312,
    height: 2.13559,
    rx: 1.0678,
    fill: "#868CA6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 22.4237H19.125C19.125 22.4237 19.125 37.3729 19.125 41.644C19.125 46.6459 15.4442 60.8644 15.4442 60.8644C15.7821 61.4972 16.3135 61.9322 17 61.9322C18.0296 61.9322 18.7105 60.9534 18.9125 59.7966C18.9125 59.7966 22.3125 45.9152 22.3125 41.644C22.3125 37.3729 22.3125 22.4237 22.3125 22.4237Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6875,
    y: 19.2203,
    width: 10.625,
    height: 1.0678,
    fill: "#577898"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5053 17.0847C7.91557 17.0847 7.4375 17.5628 7.4375 18.1525C7.4375 18.7422 7.91557 19.2203 8.5053 19.2203H24.9635C24.9652 19.2203 24.967 19.2203 24.9688 19.2203C25.2622 19.2203 25.5 19.4593 25.5 19.7542C25.5 20.0491 25.2622 20.2881 24.9688 20.2881V22.4237C26.4358 22.4237 27.625 21.2285 27.625 19.7542C27.625 18.2799 26.4358 17.0847 24.9688 17.0847C24.967 17.0847 24.9652 17.0847 24.9635 17.0847H8.5053Z",
    fill: "#868CA6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.625,
    y: 26.6949,
    width: 12.75,
    height: 12.8136,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.125,
    y: 26.6949,
    width: 4.25,
    height: 12.8136,
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTube);
export default __webpack_public_path__ + "static/media/test_tube.e5865810e01e89b8840ea865a8a3d6b0.svg";
export { ForwardRef as ReactComponent };